var _circle, _g, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _circle2, _circle3, _path6, _g2, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 230,
    viewBox: "0 0 213 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 105.5,
    cy: 124.5,
    r: 105.5,
    fill: "#E0E5EC",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2883_277414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 179,
    width: 124,
    height: 12,
    fill: "#1B3554"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 15,
    width: 124,
    height: 79,
    fill: "#E0E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 15V135H24V62.4366L34.0016 47.0864L44 15Z",
    fill: "#CFD4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167 15V135H187V62.4366L176.998 47.0864L167 15Z",
    fill: "#CFD4DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62H187V198C187 200.761 184.761 203 182 203H29C26.2386 203 24 200.761 24 198V62Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 117.548C73 116.848 73.3594 116.197 73.9811 115.876C75.3648 115.162 78.0086 114 80.5778 114C83.146 114 85.7143 115.161 87.0525 115.875C87.6555 116.198 88 116.835 88 117.519C88 119.129 86.1457 120.185 84.6307 119.639C83.4137 119.201 81.9827 118.846 80.54 118.846C79.0687 118.846 77.5975 119.215 76.3503 119.666C74.8381 120.211 73 119.156 73 117.548Z",
    fill: "#1B3554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124 117.548C124 116.848 124.359 116.197 124.981 115.876C126.365 115.162 129.009 114 131.578 114C134.146 114 136.714 115.161 138.053 115.875C138.656 116.198 139 116.835 139 117.519C139 119.129 137.146 120.185 135.631 119.639C134.414 119.201 132.983 118.846 131.54 118.846C130.069 118.846 128.597 119.215 127.35 119.666C125.838 120.211 124 119.156 124 117.548Z",
    fill: "#1B3554"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 106,
    cy: 138.003,
    rx: 16,
    ry: 7.00303,
    fill: "#1B3554"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 69,
    cy: 77,
    r: 6,
    fill: "#1B3554"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 142,
    cy: 77,
    r: 6,
    fill: "#1B3554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69 76.6926V39.5C69 19.3416 85.3416 3 105.5 3C125.658 3 142 19.3416 142 39.5V76.6926",
    stroke: "#5E7085",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2883_277414)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.6,
    cy: 175.6,
    r: 17.6,
    fill: "url(#paint0_linear_2883_277414)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.244 176.418C182.244 180.166 183.37 182.965 186.996 182.965C190.621 182.965 191.748 180.166 191.748 176.418C191.748 172.704 190.621 169.923 186.996 169.923C183.37 169.923 182.244 172.704 182.244 176.418ZM189.319 176.418C189.319 178.706 189.073 180.677 186.996 180.677C184.919 180.677 184.673 178.706 184.673 176.418C184.673 174.218 184.919 172.211 186.996 172.211C189.073 172.211 189.319 174.218 189.319 176.418Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2883_277414",
    x: 18.8131,
    y: 154.813,
    width: 172.374,
    height: 60.3739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.0935,
    result: "effect1_foregroundBlur_2883_277414"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2883_277414",
    x: 161,
    y: 152,
    width: 51.1992,
    height: 51.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.415686 0 0 0 0 0.596078 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2883_277414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2883_277414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2883_277414",
    x1: 186.6,
    y1: 140.4,
    x2: 151.4,
    y2: 175.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWishlist);
export default __webpack_public_path__ + "static/media/empty-wishlist.df1d02c62a3f51eaeac82591fb73b831.svg";
export { ForwardRef as ReactComponent };